import { onDismiss, onToastMessage } from '../../../api/actions/toast/host'
import { onThemeSyncRequest } from '../../../api/actions/theme/host'
import { useEffect } from 'react'

const subscribers = [onToastMessage, onDismiss, onThemeSyncRequest]

export const useHostEventsListeners = () => {
  useEffect(() => {
    const unsubscribers = subscribers.map((subscriber) => subscriber())

    return () => {
      unsubscribers.forEach((unsubscribe) => unsubscribe())
    }
  }, [])
}
